import * as type from './mutations-types.js'

import Vue from 'vue'

const debug = process.env.NODE_ENV != 'production'
let apiVersion = "/education-intf/api"
if (!debug) {
  apiVersion = "/education-intf/api"
}
import {get,post} from '../../../common/api/http.js'
export default {
  //获取地市
  getAreaTree: ({ commit, dispatch, state }, data) => {
    post(apiVersion + "/common/getAreaTree", { data: data }).then((response) => {
        commit(type.GET_getAreaTree, response);
    });
  },
  classCode: ({ commit, dispatch, state }, data) => {
    post(apiVersion + "/common/getDictList", { data: data }).then((response) => {
        if (response.code == 0) {
            commit(type.CLASSCODE, response);
        }
    });
  },
  submitHospital: ({ commit, dispatch, state }, data) => {
    post(apiVersion + "/company/addCompanyInfo", { data: data }).then((response) => {
        commit(type.GET_SUBMITHOSPITAL, response);
    });
  },
  areaHospitalByParam: ({ commit, dispatch, state }, data) => {
    post(apiVersion + "/company/getAreaHospitalByParam", { data: data }).then((response) => {
        if (response.code == 0) {
            commit(type.GET_AREAHOSPITAL, response);
        }
    });
  },
}
